var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.windowScrollTop >= 250)?_c('div',{staticClass:"go-to-top",style:({
      bottom: `${this.gapFromFooter}`,
    }),attrs:{"id":"go-to-top"},on:{"click":_vm.scrollToTop}},[_c('svg',{attrs:{"width":"24","height":"15","viewBox":"0 0 24 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M22 13L12 3L2 13","stroke":"#483A5B","stroke-width":"3"}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }